<template>
  <div class="russia-list">
    <div class="row">
      <div class="col-md-3 russia-list__col" v-for="(item, index) in russiaList" :key="`event-${index}`">
        <slot :item="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    russiaList: Array
  }
}
</script>

<style lang="scss" scoped>
.russia-list {
  &__col {
    margin-bottom: 30px;
  }
}
</style>
